import React, {useState, useContext} from "react";
import AuthContainer from "../../containers/AuthContainer";
import {ContentAuth, CardAuth, TitleAuth, CardOptions, FormAuth, ContainerButtons} from "./components/AuthStyles";
import {Content} from "../../styles/GlobalStyles";
import {returnAge} from "../../constants/Helpers";
import AppLoader from "../../components/loaders/Loader";
import {GlobalContext} from "../../context/GlobalContext";
import styled from "styled-components";
import Color from "../../assets/Colors";
import GetUpdateComponent from "./components/GetUpdateProfile";
import {UpdateProfileService} from "../../services/UserServices";
import {useHistory} from "react-router-dom";

export default function UpdateProfile() {
   const {token, userData} = useContext(GlobalContext);
   const [errorsList, setErrors] = useState([]); // {name: "", text: ""}
   const [isLoading, setLoading] = useState(false); // evitar muchos clicks
   let history = useHistory();

   const doRegister = (e) => {
      e.preventDefault();
      setLoading(true);
      setErrors([]);
      let yearB = Number(e.target.dateYear.value);
      let monthB = Number(e.target.dateMonth.value);
      let dayB = Number(e.target.dateDay.value);
      let birthDay = yearB > 0 && monthB > 0 && dayB > 0 ? returnAge(new Date(yearB, monthB, dayB)) : userData.age;
      // console.log(birthDay);
      /// obtener los datos
      let newData = {
         idRol: 1,
         idRegisterType: 1,
         userName: e.target.name.value,
         userLastName: e.target.userLastName.value,
         age: birthDay,
         idSex: e.target.idSex.value,
         industryExperience: e.target.industryExperience.value,
         certification: e.target.certified.value !== "otro" ? e.target.certified.value : e.target.certifiedName.value,
         email: e.target.email.value,
         // pwd: e.target.pwd.value,
         // pwdConfirm: e.target.pwdConfirm.value,
         // idSecurityQuestion: e.target.idSecurityQuestion.value,
         // securityAnswer: e.target.securityAnswer.value,
         idExpYears: e.target.idExpYears.value || userData.idExpYears,
         workplace: e.target.workplace.value || userData.workplace,
         position: e.target.position.value || userData.position,
         city: e.target.city.value,
         token,
      };

      console.log(newData);
      // validar que contraseña coincida

      if (newData.pwd !== newData.pwdConfirm) {
         setLoading(false);
         return setErrors([{name: "password", text: "La contraseña no coincide"}]);
      }

      UpdateProfileService(newData)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            console.log(resp);
            if (status === "error") throw new Error();
            // history.replace("/perfil");
         })
         .then((res) => {
            setLoading(false);
         })
         .catch((e) => {
            setLoading(false);
            console.log(e);
         });

      /*  setAuth({...auth, email: toSave.email});
      setSuccess(true);
      setLoading(true);
      window.scrollTo({top: 0, behavior: "smooth"}); 

      RegisterService(toSave)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") {
               if (resp.message === "User already exists") {
                  setErrors([{name: "email", text: "El correo ya está registrado, inicia sesión o intenta con otro correo"}]);
                  if (status === "error") throw new Error();
                  // return false;
               }
            }
            setAuth({...auth, email: toSave.email});
            setSuccess(true);
            setLoading(false);

            return true;
         })
         .then((status) => {
            if (status) window.scrollTo({top: 0, behavior: "smooth"});
         })
         .catch((e) => {
            console.log(e);
            setLoading(false);
         }); */
   };
   return (
      <>
         <AuthContainer>
            <Content>
               <ContentAuth>
                  <CardAuth>
                     <CardOptions>
                        <div className="head">
                           <TitleAuth>Editar perfil</TitleAuth>
                        </div>
                        <ContainerButtons></ContainerButtons>
                        <FormAuth onSubmit={doRegister}>
                           <GetUpdateComponent errorsList={errorsList} />
                        </FormAuth>
                     </CardOptions>
                  </CardAuth>
               </ContentAuth>
            </Content>
         </AuthContainer>
         <AppLoader isVisible={isLoading} />
      </>
   );
}

const BoldText = styled.div`
   width: 100%;
   margin-top: 3em;

   & p {
      color: ${Color.primary};
      font-size: 1.3em;
      font-weight: bold;
   }

   @media screen and (max-width: 1600px) {
      & p {
         font-size: 1em;
      }
   }
`;
